var images = {
  poster: {
    borderRadius: "medium",
    display: "block"
  }
};
export default images;